import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { UserLayoutComponent } from './components/user-layout/user-layout.component';
import { EndUserRouting } from './end-user-routing.module';
import { MaterialModule } from '@app/material/material.module';
import { InfiniteScrollDirective, InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedModule } from '@app/shared/shared.module';
import { CartComponent } from './components/cart/cart.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WishlistComponent } from './components/wishlist/wishlist.component';
import { EnduserProfileComponent } from './components/enduser-profile/enduser-profile.component';
import { NgxPayPalModule } from 'ngx-paypal';
import { SavedDesignsComponent } from './components/saved-designs/saved-designs.component';
import { PaymentfailedComponent } from './components/paymentfailed/paymentfailed.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { HttpClientModule } from '@angular/common/http';
// import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { AboutusComponent } from './components/aboutus/aboutus.component';
import { StoreTermsAndConditionComponent } from './components/store-terms-and-condition/store-terms-and-condition.component';
import { StorePrivacyAndPolicyComponent } from './components/store-privacy-and-policy/store-privacy-and-policy.component';
import { StoreHomepageComponent } from './components/store-homepage/store-homepage.component';
import { StoreEditorModule } from '@app/feature/store-editor/store-editor.module';
import { ViewstoreComponent } from '@app/feature/end-user/components/viewstore/viewstore.component';
import { CartItemComponent } from './components/cart/cart-item/cart-item.component';
import { AddressListComponent } from './components/cart/address-list/address-list.component';
import { InvoiceListComponent } from './components/invoice-list/invoice-list.component';
import { BraintreePaymentComponent } from './components/braintree-payment/braintree-payment.component';
import { NgxMaskDirective } from 'ngx-mask';
@NgModule({
    imports: [
        CommonModule,
        EndUserRouting,
        MaterialModule,
        InfiniteScrollModule,
        MatStepperModule,
        SharedModule,
        MatRadioModule,
        FormsModule,
        ReactiveFormsModule,
        NgxPayPalModule,
        ColorPickerModule,
        HttpClientModule,
        NgxMaskDirective,
        // MalihuScrollbarModule.forRoot(),
        StoreEditorModule,
        InfiniteScrollDirective

    ],
    declarations: [
        UserLayoutComponent,
        PaymentfailedComponent,
        AboutusComponent,
        StoreTermsAndConditionComponent,
        StorePrivacyAndPolicyComponent,
        StoreHomepageComponent,
        CartItemComponent,
        BraintreePaymentComponent,
        ViewstoreComponent,
        CartComponent,
        WishlistComponent,
        EnduserProfileComponent,
        SavedDesignsComponent,
        InvoiceListComponent,
        AddressListComponent,

    ],
    exports: [
    ],
    providers: [CurrencyPipe]
})
export class EndUserModule { }
